module.exports = __webpack_public_path__ + "img/email.6f0d7997.png";